import { axios } from '@/utils/request'

const api = {
  master: '/master/master',
}

export function queryMasterBlack(parameter) {//查看师傅合同列表
  return axios({
    url: api.master + '/queryMasterBlack',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectCityName  (parameter) {
  return axios({
    url: api.master + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function recoverMaster  (parameter) {
  return axios({
    url: api.master + '/recoverMaster',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}




export function importMaster(parameter) {//导入师傅列表
  return axios({
    url: api.master + '/importMaster',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const accessoryExport = api.accessory + '/export'